import { Checkbox, Link } from "@fluentui/react-components";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import { ErrorMessageContainer, Flex, Grid, StyledErrorMessage } from "components/styled";

import { useGetConsentLink } from "./hooks/useGetConsentLink";

export function MainConsentField() {
  const { t } = useTranslation();

  const consentLink = useGetConsentLink();
  const { values, errors, setFieldValue } = useFormikContext<FormData>();
  return (
    <Grid gridColumns={1} data-help="profile-main-consent">
      <Flex align="center">
        <Checkbox
          name={"isConsentGiven"}
          checked={values["isConsentGiven"]}
          onChange={(ev, data) => {
            setFieldValue("isConsentGiven", !!data.checked);
          }}
          label={""}
        />
        <Flex align="baseline">
          <Link
            target="_blank"
            href={consentLink}
            style={{
              textDecoration: "underline",
            }}
          >
            {t("hbh.iAgreeToConsentText.label")}
          </Link>
        </Flex>
      </Flex>
      <ErrorMessageContainer>
        <StyledErrorMessage>{errors["isConsentGiven"]}</StyledErrorMessage>
      </ErrorMessageContainer>
    </Grid>
  );
}
